import OnedioCSDK from '@onedio/chatty-sdk-web';
import { HOST_URL, LINK_PROD } from '~/constants/config';
const isProdOnedio = HOST_URL === LINK_PROD;
const isLocal = process.client ? document.location.hostname === 'localhost' : true;

export default ({ res }, inject) => {
  const defaultParams = {
    host: isProdOnedio && !isLocal ? 'chatty.onedio.com' : 'chatty-dev.onedio.com',
    secure: true,
    debugMode: false,
  };

  const socket = {
    Init: async ({ cidChangeCallback }) => {
      await OnedioCSDK.Init({
        ...defaultParams,
        cidChangeCallback,
      });
    },
    Subscribe: ({ topicIds, callback }) => {
      OnedioCSDK.Subscribe({
        topicIds,
        callback,
      });
    },
    Unsubscribe: ({ topicIds, callback }) => {
      OnedioCSDK.Unsubscribe({
        topicIds,
        callback,
      });
    },
    BindMeta: () => {
      OnedioCSDK.BindMeta({});
    },
    GetSocketState: async () => {
      return await OnedioCSDK.GetSocketState();
    },
    GetTopicIds: async () => {
      return await OnedioCSDK.GetTopicIds();
    },
    GetClientId: async () => {
      return await OnedioCSDK.GetClientId();
    },
  };

  inject('socket', socket);
};
